<template>
  <transition name="fade">
    <Modal v-show="showModal">
      <div slot="content" :style="{'text-align': 'center'}">
        <p>
          <RawHtml :text="message">{{ message }}</RawHtml>
        </p>
        <button class="btn" @click="reload"><fa-icon icon="redo" />再読み込み</button>
      </div>
    </Modal>
  </transition>
</template>

<script>
import Modal from "../elements/Modal"
import RawHtml from "../elements/RawHtml"

export default {
  name: "RequestReloadModal",
  components: {
    Modal,
    RawHtml
  },
  computed: {
    showModal() {
      return this.$store.getters["requestReload/disconnected"]
    },
    message() {
      return this.$store.getters["requestReload/message"]
    }
  },
  methods: {
    reload: function() {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>

<style scoped></style>
